import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 80"
    >
      <text
        x="4"
        y="62"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="900"
        fontSize="62"
        fill="currentColor"
        letterSpacing="-2"
      >
        N
      </text>
      <text
        x="50"
        y="62"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="900"
        fontSize="62"
        fill="currentColor"
        letterSpacing="-2"
      >
        i
      </text>
      <circle cx="58" cy="12" r="6" fill="#4da6ff" />
      <text
        x="68"
        y="62"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="900"
        fontSize="62"
        fill="currentColor"
        letterSpacing="-2"
      >
        CE
      </text>
    </svg>
  );
};
